<script>
  import Block from './block.svelte'
  import Row from './row.svelte'
  import Column from './column.svelte'
  import Text from './text.svelte'
  import TextInput from './textinput.svelte'
  import Icon from './icon.svelte'
  import { beforeUpdate, afterUpdate } from 'svelte'
  
  export let items = [
    {name: 'AAA', value:'aaa'},
    {name: 'BBB', value:'aaa'},
    {name: 'CCC', value:'aaa'},
  ]
  export let current = -1
  export let currentValue = undefined
  export let width = '6rem'
  export let height = '2rem'
  export let border = 1
  export let borderColor = 'darkgray'
  export let placeholder = ''
  export let fontSize = '0.9rem'
  export let space = '0.4rem'
  export let hoverBgColor = 'whitesmoke'
  export let clickDismiss = true

  let fold = true

  function pageClick(e) {
    if (fold || !clickDismiss)
      return
    fold = true
    e.preventDefault()
  }

  function onClick(e) {
    if (e.defaultPrevented) return // check if just dismiss
    fold = !fold
  }

  function clickItem(index) {
    current = index
    let item = items[current]
    currentValue = item.hasOwnProperty('value') ? item.value : item
    fold = true
  }

  afterUpdate(() => {
    if (!fold && clickDismiss) {  // dismiss menu when click/rclick page other area
      window.addEventListener('click', pageClick, {once: true, capture: true})  
      window.addEventListener('contextmenu', pageClick, {once: true, capture: true})
      // capture=true otherwise pageClick will trigger by popupButton click event and dismiss immediately
    }
  })

  beforeUpdate(() => {
    if (currentValue !== undefined) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (item === currentValue || item.value === currentValue) {
          current = i
          break
        }
      }
    }
  })

</script>

<Block position=relative {width} selectable={false}>
  <Column width=100%>
    <Block
      width=100% {height} {border} {borderColor}
      on:click={onClick}
    >
      <Row xAlign=center height=100%>
        <TextInput 
          {fontSize} {placeholder} width=100% height=100% readonly={true} border=0
          value={current>=0?(items[current].name || items[current]):''}
          on:change
        />
        <Icon 
          name={fold ? 'arrow-down-bold' : 'arrow-up-bold'} 
          size={fontSize} 
        ></Icon>
        <Block width={space}/>
      </Row>

    </Block>
    <Block 
      hidden={fold} position=absolute backgroundColor=white topBorder=0
      top={height} width=100% {border} {borderColor} zIndex=1000
    >
      {#each items as item, index}
        <Block 
          width=100% {height} {hoverBgColor}
          on:click={(e)=>{clickItem(index);e.stopPropagation()}}
        >
        <Row xAlign=center {height}>
          <Block width={space}/>
          <Text size={fontSize}>{item.name || item}</Text>
        </Row>
        </Block>
      {/each}
    </Block>
  </Column>
</Block>
